import * as Sentry from '@sentry/react'

export const physicalEventCreationFormError = err => {
  Sentry.captureException(`Physical event creation failed: ${JSON.stringify(err)}`, Sentry.Severity.Warning)
}

export const onlineEventCreationFormError = err => {
  Sentry.captureException(`Online event creation failed: ${JSON.stringify(err)}`, Sentry.Severity.Warning)
}
